<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Ajouter un client</h3>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="addClient" :validation-schema="clientSchema">
        <div class="row">
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Nom du client <span class="text-danger">*</span>
              </label>
              <Field name="nomClient" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le nom" />
              <ErrorMessage name="nomClient" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Prénom du client <span class="text-danger">*</span>
              </label>
              <Field name="prenomClient" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrer le prénom" />
              <ErrorMessage name="prenomClient" class="text-danger" />
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Téléphone <span class="text-danger">*</span>
              </label>
              <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="telephone1"
                defaultCountry="BJ" mode="international" @validate="validatePhone"
                class="shadow-none fs-md-15 text-black py-2">
              </vue-tel-input>
              <div v-if="telephoneErreur" class="text-danger">Veuillez entrer un numéro correct</div>
            </div>
          </div>

          <div class="col-md-12 mt-3">
            <div class="d-flex align-items-center">
              <button ref="submitButton" class="btn btn-success me-3" type="submit">
                Ajouter un client
              </button>
              <router-link to="/clients/liste-clients" class="btn btn-danger">
                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRouter } from "vue-router";
import ApiService from '@/services/ApiService';
import * as Yup from 'yup';
import 'vue3-tel-input/dist/vue3-tel-input.css'
import { VueTelInput } from 'vue3-tel-input'

export default defineComponent({
  name: "AddClient",
  components: { Form, Field, ErrorMessage, VueTelInput },
  setup: () => {
  const router = useRouter();
  const submitButton = ref<HTMLButtonElement | null>(null);

  const clientSchema = Yup.object().shape({
    nomClient: Yup.string().required("Le nom du client est obligatoire"),
    prenomClient: Yup.string().required("Le prénom du client est obligatoire"),
  });

  const telephone1 = ref('');

  // Dernier résultat envoyé par le composant (unique source de vérité)
  const resultatTel = ref<any>(null);

  const validatePhone = (phoneObject: any) => {
    console.log('validate =>', JSON.stringify(phoneObject));
    resultatTel.value = phoneObject;
  };

  // Le numéro est valide si le composant l'a dit
  const numeroValide = computed(() => resultatTel.value?.valid === true);

  // Erreur seulement si l'utilisateur a saisi des chiffres ET que le composant dit "invalide"
  const telephoneErreur = computed(() => {
    const saisie = String(resultatTel.value?.nationalNumber ?? '').replace(/\D/g, '');
    return saisie.length > 0 && !numeroValide.value;
  });

  const addClient = async (values: any, { resetForm }: any) => {
    if (!numeroValide.value) {
      return;   // le message d'erreur s'affiche déjà sous le champ
    }

    if (submitButton.value) submitButton.value.disabled = true;

    ApiService.post("/clients", {
      nomClient: values.nomClient,
      prenomClient: values.prenomClient,
      telephone1: resultatTel.value.number,   // ex. "+22997979797", sans espaces
    })
      .then(({ data }) => {
        if (data.code == 201) {
          success(data.message);
          resetForm();
          telephone1.value = '';
          resultatTel.value = null;
          router.push({ name: "ListeClient" });
        }
      })
      .catch((err) => {
        if (submitButton.value) submitButton.value.disabled = false;
        error(err?.response?.data?.message ?? "Le client n'a pas pu être ajouté.");
      });
  };

  return { clientSchema, addClient, submitButton, telephone1, telephoneErreur, validatePhone };
},
});
</script>